

























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SuportePacientesStore from '@/components/Suporte/Store/SuportePacientesStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { onlyNumber } from '@/utils/common'

@Component
export default class ComponentModalSuportePaciente extends Vue {
  loadSaveOrUpdatePaciente: boolean = false

  get getSuportePacientesStore() {
    return getModule(SuportePacientesStore, this.$store)
  }

  get loadingSaveOrUpdatePaciente() {
    return this.loadSaveOrUpdatePaciente
  }

  set loadingSaveOrUpdatePaciente(value: boolean) {
    this.loadSaveOrUpdatePaciente = value
  }

  get showModalPaciente() {
    return this.getSuportePacientesStore.modal.paciente
  }

  set showModalPaciente(value: boolean) {
    this.getSuportePacientesStore.setModal({ name: 'paciente', value })
  }

  $refs!: {
    formPaciente: any
  }

  tipoPacienteEnum = [
    { value: null, text: 'Normal' },
    { value: 'RecemNascido', text: 'Recém nascido' },
    { value: 'MenorDe12', text: 'Menor de 12 anos' },
    { value: 'Estrangeiro', text: 'Estrangeiro' },
  ]

  formPacienteRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    dataNascimento: [],
    nomeSocial: [],
    nomeMae: [],
    sexo: [],
    email: [],
    telefone: [],
    celular: [],
    cpf: [],
    pacienteNaoPossuiCpf: [],
    cpfResponsavel: [],
    certidaoNascimentoFolha: [],
    certidaoNascimentoLivro: [],
    certidaoNascimentoTermo: [],
    rne: [],
    rgh: [],
    passaporte: [],
    nacionalidade: [],
    tipoPaciente: [],
  }

  onlyNumberUtil(value: any) {
    return onlyNumber(value)
  }

  async saveOrUpdatePaciente() {
    this.loadingSaveOrUpdatePaciente = true

    if (this.$refs.formPaciente.validate()) {
      const { mode } = this.getSuportePacientesStore

      const response = await this.getSuportePacientesStore.updatePaciente()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Paciente ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuportePacientesStore.getPacientesPagedSearch(this.getSuportePacientesStore.paginationPacientes)
        this.showModalPaciente = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o paciente ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdatePaciente = false
  }

  @Watch('showModalPaciente')
  onChangeshowModalPaciente(value: boolean) {
    if (!value) {
      this.getSuportePacientesStore.clearPaciente()
      this.getSuportePacientesStore.setMode({ mode: 'CREATE' })
      this.$refs.formPaciente.resetValidation()
    }
  }
}
